// extracted by mini-css-extract-plugin
export default {"SubmitButton":"MultipleChoice_SubmitButton__BnRgC","FormFieldContainer":"MultipleChoice_FormFieldContainer__HV57N","FormField":"MultipleChoice_FormField__5EOAV"};